import { AxiosError } from 'axios';
import { ICategoryTour } from 'client/models/ICategoryTour';
import {
  AddCategoryTourTypes,
  GetCategoryTourTypes,
  getAllCategoryTourTypes,
  deleteCategoryTourTypes,
  GetCategoryTourByIdTypes,
} from 'client/_redux/types/categoryTourTypes';
import { IReduxAction } from 'types/IReduxAction';

export interface CategoryTourState {
  error?: AxiosError | Error;
  currentCategoryTour?: ICategoryTour;
  allCategoryTours?: { categoryTours: ICategoryTour[]; total: number };
  categoryTourDetails?: ICategoryTour;
}

const initialState: CategoryTourState = {};

export default (
  state: CategoryTourState = initialState,
  action: IReduxAction,
): CategoryTourState => {
  const { type, payload, error } = action;

  switch (type) {
    case AddCategoryTourTypes.ADD_CATEGORY_TOUR_SUCCESS:
      return {
        ...state,
        currentCategoryTour: payload.categoryTour,
      };
    case AddCategoryTourTypes.ADD_CATEGORY_TOUR_FAILURE:
      return {
        ...state,
        error,
      };
    case AddCategoryTourTypes.UPDATE_CATEGORY_TOUR_SUCCESS:
      return {
        ...state,
        currentCategoryTour: payload.categoryTour,
      };
    case AddCategoryTourTypes.UPDATE_CATEGORY_TOUR_FAILURE:
      return {
        ...state,
        error,
      };
    case deleteCategoryTourTypes.CATEGORY_TOUR_DELETE_SUCCESS:
      return {
        ...state,
        currentCategoryTour: undefined,
      };
    case deleteCategoryTourTypes.CATEGORY_TOUR_DELETE_FAILURE:
      return {
        ...state,
        error,
      };
    case getAllCategoryTourTypes.CATEGORY_TOUR_SUCCESS:
      return {
        ...state,
        allCategoryTours: payload,
      };
    case getAllCategoryTourTypes.CATEGORY_TOUR_FAILURE:
      return {
        ...state,
        error,
      };
    case GetCategoryTourByIdTypes.CATEGORY_TOUR_BYID_SUCCESS:
      return {
        ...state,
        categoryTourDetails: payload.categoryTour,
      };
    case GetCategoryTourByIdTypes.CATEGORY_TOURBYID_FAILURE:
      return {
        ...state,
        error,
      };
    case GetCategoryTourTypes.RESET_CATEGORY_TOUR:
      return initialState;
    default:
      return state;
  }
};
